var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"special-sale"},[_c('navbar',{ref:"navbar",attrs:{"show-home":"","title":"会员特卖专场"}}),_c('div',{staticClass:"special-sale-container"},[_c('cont-nav',{ref:"contNav",attrs:{"nav-height":_vm.navbarHeight,"nav-list":_vm.navList}})],1),_c('back-top',{attrs:{"show-back":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }